import StepperInput from '../Common/StepperInput';

const StepperInputWrapper = objProps => {
  return <StepperInput {...objProps.field} {...objProps} />;
};

export default StepperInputWrapper;
